import React from 'react'

export default function ToggleBox(props) {
    return (
        <div>
            <input type="checkbox" onChange={() => props.handler(!props.isChecked)} />
            <label>{props.title}</label>
        </div>
    )
}